export default "__VITE_ASSET__b7$YnnRF__"